import MasterService from '../services/MasterService';

interface OtpRequest {
    // Define the structure of the 'params' object here
    email: string;
    password?: string;
    captcha?: string;
    resendOtp?: boolean;
  }

interface LoginRequest {
    email: string;
    password?: string; 
    captcha?: string; 
    hash ?: string;
    source: string;
}

  interface DeleteAccount {
    // Define the structure of the 'params' object here
    email: string;
    otp : string;
  }


  export interface ChangePassword {
    // Define the structure of the 'params' object here
    otp : string;
    password: string;
  }

  interface CreateNewPassword {
    // Define the structure of the 'params' object here
    email: string;
    password: string;
    confirm_password: string;
  }

  interface DuplicateCheckRequest {
    // Define the structure of the 'params' object here
    email?: string;
    mobile?: string;
    ktp_id?: string;
    npwp_no?: string;
    account_no?: string;
    referral?: string;
  }

  interface SendOtpToRegistrationRequest {
    // Define the structure of the 'params' object here
    email: string;
    source?: string;
    captcha?: string;
    hash?: string;
  }

  interface RegisterRequest {
    // Define the structure of the 'params' object here
    email: string;
    name: string;
    mobile: string;
    source?: string;
    captcha?: string;
    hash?: string;
    [key: string]: any;
  }

export const UserService = {
    ...MasterService,

    Login(params: LoginRequest) {
        return this.post('/agency/auth/login', params)
    },
    loginCaptcha() {
        return this.post('/userAdminAuth/getCaptchaImage')
    },

    googleWithLogin(params: OtpRequest) {
      return this.post('/agency/auth/googleWithLogin', params)
    },

    SendOtpToDeleteAccount(params:OtpRequest) {
      return this.post('/agency/auth/sendOtpToDeleteAccount', params)
    },

    deleteAccount(params:DeleteAccount) {
        return this.post('/agency/auth/deleteAcount', params)
    },

    createOtp(params: OtpRequest) {
      return this.post('/agency/auth/register', params)
    },

    VerifyOtp(params: OtpRequest) { // this is changes otpRequest
      return this.post('/agency/auth/verifyOtp', params)
    },

    sendOtpToForgotPassword(params:OtpRequest) {
      return this.post('/agency/auth/sendOtpToForgotPwd', params)
    },

    otpVerifiedToForgotPassword(params:DeleteAccount) {
      return this.post('/agency/auth/OtpVerifyForgotPwd', params)
    },

    verifyOtpPassword(params:ChangePassword) {
      return this.post('/agency/api/verifyOtpPassword', params)
    },

    addNewPasswordToForgotPassword(params:CreateNewPassword) {
      return this.post('/agency/auth/forgotAddNewPwd', params)
    },

    deleteAccountID(params:DeleteAccount) {
        return this.post('/api/agent-app/delete-account', params)
    },

    duplicateCheck(params: DuplicateCheckRequest) {
      return this.post('/agency/auth/duplicateCheck', params)
    },

    sendOtpToRegistration(params: SendOtpToRegistrationRequest) {
      return this.post('/agency/auth/sendOtpToRegistration', params)
    },

    register(params: RegisterRequest) {
      return this.post('/agency/auth/register', params)
    },

}